import React, { useEffect, useState } from 'react';
import BackgroundImage from '@/operator/components/general/BackgroundImage';
import { StyledTwoScreensWrapper } from '@/operator/components/modules/AuthPage/Styles';
import { MessageWithTip } from '@/operator/components/modules/AuthPage/setup/MessageWithTip';
import CircularProgress from '@mui/material/CircularProgress';
import { useAppContext } from '@/operator/context/AppContext';
import { useTranslation } from 'react-i18next';
import { useOrgNavigate } from "app/routes/useOrgNavigate";
import { ROUTES } from '@/routes/constants';
import { useHandleUserSessionData } from '@/operator/hooks/useHandleUserSessionData';
import { useUserOrgs } from '@/operator/hooks/useUserOrgs';
import image from '@/operator/public/assets/images/background/CheckingPage.svg';
import { UserOrg } from 'Interfaces/User/UserData';

const CheckingPage = (): JSX.Element => {
    const { t } = useTranslation();
    const { user, userOrganizations } = useUserOrgs();
    const navigate = useOrgNavigate();

    const [hasOrgs, setHasOrgs] = useState(false);
    const { setOrgList: setOrgListContext } = useAppContext();

    const { removeSessionData } = useHandleUserSessionData();

    const onSuccessHandler = (orgs: UserOrg[]) => {
        if (orgs?.length) {
            setHasOrgs(true);
            setOrgListContext(orgs);
        }
    };

    useEffect(() => {
        removeSessionData();
    }, []);

    useEffect(() => {
        onSuccessHandler(userOrganizations);
    }, [userOrganizations]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (user) {
                if (hasOrgs) {
                    navigate(ROUTES.AUTH_LOGIN);
                } else {
                    navigate(ROUTES.AUTH_SETUP_ONBOARDING);
                }
            }
        }, 3300); // Wait for 3.3 seconds before executing the code inside setTimeout

        // Clean up the timer when the component unmounts or the dependency changes
        return () => clearTimeout(timeout);
    }, [user, hasOrgs]);

    return (
        <StyledTwoScreensWrapper>
            <MessageWithTip
                Icon={CircularProgress}
                headline={t('Auth.Setup.Checking.Content.Header')}
                description={t('Auth.Setup.Checking.Content.Description')}
                tip={t('Auth.Setup.Checking.Content.Tip.Message')}
            />

            <BackgroundImage src={image} />
        </StyledTwoScreensWrapper>
    );
};

export default CheckingPage;
